<div class="row ss-top-menu">
  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/']">Dashboard</span> 
    <span style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-light ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/community_manager/leads']" [queryParams]="{lead_status: lead_status}" *ngIf="(role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager')">Lead</span>
    <span class="ss-link" style="vertical-align: -webkit-baseline-middle;" [routerLink]="['/designer/leads']" [queryParams]="{customer_status: lead_details.lead_status}" *ngIf="role=='designer'">Lead </span>
    <span *ngIf="lead_details" class="capitalize" style="vertical-align: -webkit-baseline-middle;"><i class="rightArrow fa fa-angle-right"></i> {{lead_details.lead_status | replaceChar}}</span>
    <span style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details.user_reference"><i class="rightArrow fa fa-angle-right"></i> </span>
    <span class="ss-text-dark capitalize" style="vertical-align: -webkit-baseline-middle;" *ngIf="lead_details.user_reference">{{lead_details.user_reference.name}}</span>
    <!-- <span class="ss-text-dark" style="vertical-align: -webkit-baseline-middle;">{{lead_logs.name}}</span> -->
  </div>
</div>

<div class="row px-4">
  	<div class="col-md-12 p-0 mt-4">
	    <ul class="nav nav-tabs ss-nav-tabs" id="myTab" role="tablist">
	    	<li class="nav-item">
				<a class="nav-link active ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" routerLink="/lead/{{lead_id}}/overview" [queryParams]="{lead_status: lead_status}">Overview</a>
			</li>
			<li class="nav-item">
				<a class="nav-link  ss-nav-link" id="home-tab" data-toggle="tab" role="tab" aria-controls="home" aria-selected="true" routerLink="/lead/{{lead_id}}/activity-logs" [queryParams]="{lead_status: lead_status}">Activity Logs</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="profile-tab" data-toggle="tab" role="tab" aria-controls="profile" aria-selected="false" routerLink="/lead/{{lead_id}}/basic-info" [queryParams]="{lead_status: lead_status}">Basic Info</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="contact-tab" data-toggle="tab" role="tab" aria-controls="contact" aria-selected="false" routerLink="/lead/{{lead_id}}/detailed-info" [queryParams]="{lead_status: lead_status}">Detailed Info</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="boq-tab" data-toggle="tab" role="tab" aria-controls="boq" aria-selected="false" routerLink="/lead/{{lead_id}}/boq" [queryParams]="{lead_status: lead_status}">BOQ</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="ppt-tab" data-toggle="tab" role="tab" aria-controls="ppt" aria-selected="false" routerLink="/lead/{{lead_id}}/ppt" [queryParams]="{lead_status: lead_status}">PPT</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="files-tab" data-toggle="tab" role="tab" aria-controls="files" aria-selected="false" routerLink="/lead/{{lead_id}}/files" [queryParams]="{lead_status: lead_status}">Files</a>
			</li>
			<li class="nav-item">
				<a class="nav-link ss-nav-link" id="calendar-tab" data-toggle="tab" href="#calendar" role="tab" aria-controls="files" aria-selected="false" routerLink="/lead/{{lead_id}}/calendar" [queryParams]="{lead_status: lead_status}">Calendar</a>
			</li>
			<li class="nav-item">
			  <a class="nav-link ss-nav-link" id="proposal-tab" data-toggle="tab" href="#proposals" role="tab" aria-controls="proposals" aria-selected="false" routerLink="/lead/{{lead_id}}/proposals" [queryParams]="{lead_status: lead_status}">Proposals</a>
			</li>
			<li class="nav-item" >
	          <a class="nav-link ss-nav-link "  id="proposal-tab" data-toggle="tab" href="#custom" role="tab" aria-controls="custom" aria-selected="false" routerLink="/lead/{{lead_id}}/custom-view" [queryParams]="{lead_status: lead_status}">Custom Element</a>
	        </li>
	        <li class="nav-item" >
		        <a class="nav-link ss-nav-link" id="proposal-tab" data-toggle="tab" href="#proposals" role="tab" aria-controls="proposals" aria-selected="false" routerLink="/lead/{{lead_id}}/payments" >Payments</a>
		    </li>
		    <li class="nav-item" *ngIf="isProjectInWip() && role=='city_gm' || role=='business_head' || role=='community_manager' || role=='design_manager'">
		        <a class="nav-link ss-nav-link {{payment_approval_tab}}" id="proposal-approve-tab" data-toggle="tab" href="#proposals-approve" role="tab" aria-controls="proposal-approve" aria-selected="false" routerLink="/lead/{{lead_id}}/proposal-approve" >Proposal Approve</a>
		    </li>
		    <li class="nav-item" *ngIf="isProjectInWip()">
		        <a class="nav-link ss-nav-link {{handover_for_production}}" id="handover-for-production-tab" data-toggle="tab" href="#handover-for-production" role="tab" aria-controls="handover-for-production" aria-selected="false" routerLink="/lead/{{lead_id}}/handover-for-production" [queryParams]="{lead_status: lead_status}" >Handover/Feasibility</a>
		    </li>
	   
	    </ul>
  	</div>
  	<div class="col-12 bg-white mb-3">
  		
  		<div class="col-lg-12 mt-5 mb-2">
			<h5 class="titleText">Events till today's date</h5>
		</div>
		<div class="row">
			<div class="col-md-12 text-center p-5" *ngIf="initLoader">
	            <div class="ss-spinner ss-spinner--orange">
	              <div class="ss-spinner__item1"></div>
	              <div class="ss-spinner__item2"></div>
	              <div class="ss-spinner__item3"></div>
	              <div class="ss-spinner__item4"></div>
	            </div>
          	</div>
			<div class="col-sm-4 my-3" *ngIf="future_event_count">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Meetings</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#detailModal" data-toggle="modal" (click)="getOverviewLog('past','meeting_fixed')">{{past_event_count.no_of_meeting}}</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count shows that {{past_event_count.no_of_meeting}} are held till date for this project.</p>
				    </div>
				</div>
			</div>
			<div class="col-sm-4 my-3" *ngIf="future_event_count">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Calls</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#calldetailModal" data-toggle="modal" (click)="getOverviewCallLog('past','calls')">{{past_event_count.no_of_calls}}</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count shows that {{past_event_count.no_of_calls}} calls has been done for this project.</p>
				    </div>
				</div>
			</div>
			<!-- <div class="col-sm-4 my-3">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Visits</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#detailModal" data-toggle="modal">15</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count of all the leads which have been entered into the system till date.</p>
				    </div>
				</div>
			</div> -->
		</div>
		<div class="col-lg-12 mt-3 mb-2">
			<h5 class="titleText">Upcoming Events</h5>
		</div>
		<div class="row" *ngIf="future_event_count"> 
			<div class="col-sm-4 my-3">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Meetings</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#detailModal" data-toggle="modal" (click)="getOverviewLog('future','meeting_fixed')">{{future_event_count.no_of_meeting}}</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count shows that {{future_event_count.no_of_meeting}} are being scheduled for future for this project.</p>
				    </div>
				</div>
			</div>
			<div class="col-sm-4 my-3">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Calls</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#calldetailModal" data-toggle="modal" (click)="getOverviewCallLog('future','calls')">{{future_event_count.no_of_calls}}</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count shows that {{future_event_count.no_of_calls}} calls has been scheduled for future for this project.</p>
				    </div>
				</div>
			</div>
			<!-- <div class="col-sm-4 my-3">
				<div class="card py-2 px-2">
					<div class="mt-3 mb-4 ml-2 mr-1">
						<div class="row">
							<div class="col-4">
								<img src="assets/v3/img/lost.svg" class="cardHeadingIcon">
							</div>
							<div class="col-8 d-flex align-items-center">
				  				<span class="statusCardHeadingColor">No. of Visits</span>
				  			</div>
				  		</div>
				    </div>
				    <h1 class="card-title text-center statusCardTextColor mt-4 mb-5 addCursor" data-target="#detailModal" data-toggle="modal">1</h1>
				    <div class="ml-3 mr-2 statusCardContent">
				    	<p>Count of all the leads which have been entered into the system till date.</p>
				    </div>
				</div>
			</div> -->
		</div>
  	</div>
</div>



<div class="modal fade customModal" id="detailModal" tabindex="-1" role="dialog" aria-labelledby="detailModalLabel" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title modalTitle" id="detailModalLabel"> Details</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
				</button>
			</div>
			<div class="modal-body">
				<div class="row justify-content-center">
					<div class="col-sm-12">

						<div class="tableDiv table-responsive lappyView">
							<p class="text-center" *ngIf="(eventlogs && eventlogs.length==0) || eventlogs==null">No Data</p>
							<table class="table" *ngIf="eventlogs && eventlogs.length>0">
								<thead class="thead-dark">
									<tr>
										<th class="firstTh">#</th>
										<th>Agenda</th>
										<th>Created At</th>
										<th>Scheduled At</th>
										<th>Status</th>
										<th>Last Updated</th>
										<th>Created By</th>
										<th>Members</th>
										<th>Location</th>
										<th>Type</th>
										<th class="lastTh">Description</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let log of eventlogs; let i = index" [attr.data-index]="i">
										<td>{{i+1}}</td>
										<td class="capitalize minWidthForTd">{{log.agenda | replaceChar}}</td>
										<td class="minWidthForTd">{{log.created_at | date:'dd MMM, yyyy , h:mm a'}}</td>	
										<td class="minWidthForTd">{{log.scheduled_at | date:'dd MMM, yyyy , h:mm a'}}</td>
										<td class="capitalize">{{log.status}}</td>	
										<td class="minWidthForTd">{{log.last_updated_at | date:'dd MMM, yyyy , h:mm a'}}</td>
										<td class="capitalize minWidthForTd">
											<span *ngIf="log.whodunnit.length>0">{{log.whodunnit[0]}} - {{log.whodunnit[2] | replaceChar}} ({{log.whodunnit[1]}})</span>
										</td>
										<td class="minWidthForTd" style="min-width: 270px;">
											<p *ngIf="log.user.length>0">
												<ng-container *ngFor="let usr of log.user">{{usr[0]}} ({{usr[1]}}), </ng-container> 
											</p>
										</td>
										<td class="capitalize">{{log.location}}</td>
										<td>{{log.contact_type}}</td>
										<td>{{log.description}}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="mobView" *ngFor="let log of eventlogs; let i = index" [attr.data-index]="i">
							<div class="card card-body mobCard mb-2">
								<a data-toggle="collapse" href="#tableDiv{{i}}">
									<i class="fa fa-angle-right"></i>
								</a>
								<h4 class="ss-link">Agenda: {{log.agenda | replaceChar}}</h4>
								<div class="row">
									<p class="col-6 mb-0">Scheduled At : {{log.scheduled_at | date:'dd MMM, yyyy , h:mm a'}}</p>
									<h6 class="col-6 mb-0">Type : {{log.contact_type}}</h6>
								</div>
							</div>
							<div class="collapse" id="tableDiv{{i}}">
								<div class="card card-body py-0 mb-3 border-0">
									<div class="row">
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">CREATED AT</p>
											<p>{{log.created_at | date:'dd MMM, yyyy , h:mm a'}}</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">CREATED BY</p>
											<p class="capitalize"><span *ngIf="log.whodunnit.length>0">{{log.whodunnit[0]}} - {{log.whodunnit[2] | replaceChar}} ({{log.whodunnit[1]}})</span>
											</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">LAST UPDATED</p>
											<p>{{log.last_updated_at | date:'dd MMM, yyyy , h:mm a'}}</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">STATUS</p>
											<p>{{log.status}}</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">MEMBERS</p>
											<p *ngIf="log.user.length>0">
												<ng-container *ngFor="let usr of log.user">{{usr[0]}} ({{usr[1]}})</ng-container>
											</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">LOCATION</p>
											<p>{{log.location}}</p>
										</div>
										<div class="col-12 py-3 borderRight">
											<p class="tableInner">DESCRIPTION</p>
											<p>{{log.description}}</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="modal fade customModal" id="calldetailModal" tabindex="-1" role="dialog" aria-labelledby="calldetailModalLabel" aria-hidden="true">
	<div class="modal-dialog" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title modalTitle" id="calldetailModalLabel"> Call Details</h5>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
					<img class="close" data-dismiss="modal" src="https://www.homepolish.com/assets/close-ee1bfd7a4473933b6dd934b2c284dc856361b63581c8f43b8cdc1abe07c91765.svg">
				</button>
			</div>
			<div class="modal-body">
				<div class="row justify-content-center">
					<div class="col-sm-12">
						<div class="tableDiv table-responsive">
							<p class="text-center" *ngIf="(eventcalllogs && eventcalllogs.length==0) || eventcalllogs==null">No Data</p>
							<table class="table lappyView" *ngIf="eventcalllogs && eventcalllogs.length>0">
								<thead class="thead-dark">
									<tr>
										<th class="firstTh">#</th>
										<th>Called At</th>
										<th>Called By</th>
										<th>Duration</th>
										<th>Status</th>
										<th class="lastTh">Recording Url</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let clog of eventcalllogs; let j = index" [attr.data-index]="j">
										<td>{{j+1}}</td>
										<td class="minWidthForTd">{{clog.called_at | date:'dd MMM, yyyy , h:mm a'}}</td>
										<td class="capitalize minWidthForTd">{{clog.whodunnit}} ({{clog.role}})</td>
										<td>
											<span *ngIf="(clog.duration!=null && clog.duration!='-')">{{clog.duration}}</span>
											<span *ngIf="(clog.duration==null || clog.duration=='-')">NA</span>
										</td>
										<td class="capitalize">
											<span *ngIf="(clog.status!=null && clog.status!='-')">{{clog.status}}</span>
											<span *ngIf="(clog.status==null || clog.status=='-')">NA</span>
										</td>
										<td>
											<audio controls *ngIf="clog.recording_url!=null && clog.recording_url!='' && clog.recording_url!='-'">
											<source src="{{clog.recording_url}}" type="audio/mpeg">Your browser does not support the audio element.
											</audio>
											<span *ngIf="clog.recording_url==null || clog.recording_url=='' || clog.recording_url=='-'">NA</span>
										</td>
									</tr>
								</tbody>
							</table>
							<div class="row my-4 mobView">
								<div class="col-12">
									<div *ngIf="eventcalllogs && eventcalllogs.length>0">
										<div *ngFor="let clog of eventcalllogs; let j = index" [attr.data-index]="j">
											<div class="card card-body mobCard mb-2">
												<a data-toggle="collapse" href="#tableDiv{{j}}">
													<i class="fa fa-angle-right"></i>
												</a>
												<h4>CALLED BY: {{clog.whodunnit}} ({{clog.role}})</h4>
												<div class="row">
													<p class="col-5 mb-0" *ngIf="(clog.duration!=null && clog.duration!='-')">DURATION: {{clog.duration}}</p>
													<p class="col-6 mb-0" *ngIf="(clog.duration==null || clog.duration=='-')">DURATION: NA</p>
													<h6 class="col-6 mb-0 text-center capitalize">
														<span *ngIf="(clog.status!=null && clog.status!='-')">{{clog.status}}</span>
														<span *ngIf="(clog.status==null || clog.status=='-')">NA</span>
													</h6>
												</div>
											</div>
											<div class="collapse" id="tableDiv{{j}}">
												<div class="card card-body py-0 mb-3">
													<div class="row">
														<div class="col-12 py-3 borderRight">
															<p class="tableInner">CALLED AT</p>
															<p class="tableInner capitalize">{{clog.called_at | date:'dd MMM, yyyy , h:mm a'}}</p>
														</div>
														<div class="col-12 py-3 borderRight">
															<p class="tableInner">RECORDING</p>
															<audio controls *ngIf="clog.recording_url!=null && clog.recording_url!='' && clog.recording_url!='-'">
																<source src="{{clog.recording_url}}" type="audio/mpeg">Your browser does not support the audio element.
															</audio>
															<span *ngIf="clog.recording_url==null || clog.recording_url=='' || clog.recording_url=='-'">NA</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/overview/overview-counts/overview-counts.component.html